import { ReactNode } from 'react'

interface AccordionHeaderProps {
  left: ReactNode
  right: ReactNode
}

export const AccordionHeader = ({ left, right }: AccordionHeaderProps) => (
  <div className="w-full flex justify-between items-center pr-1">
    {left}
    {right}
  </div>
)
